import {Platform} from 'react-native';
import {createNavigationContainerRef} from '@react-navigation/native';
import {StackActions} from '@react-navigation/native';
import {goTo} from '@/utils/route';

export const navigationRef = createNavigationContainerRef();

const isReady = () => navigationRef.isReady();

export function navigate(name, params) {
  isReady() && navigationRef.navigate(name, params);
}

export function replace(name, params) {
  isReady() && navigationRef.dispatch(StackActions.replace(name, params));
}

export function navGoBack() {
  if (
    Platform.OS === 'web' &&
    navigationRef.current.getState().routes.length < 2
  ) {
    const currentUrl = window.location.href;
    window.history.back();
    // 如果100ms后URL没变，说明无法后退
    setTimeout(() => {
      if (window.location.href === currentUrl) {
        goTo('Home');
        // 可以执行其他操作，如关闭窗口或跳转到首页
      }
    }, 100);
  } else {
    navigationRef.goBack();
  }
}
